import './about.css'
import React from 'react'
// component
import About_Me from '../../assets/me-about.jpg'
import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'
import {VscFolderLibrary} from 'react-icons/vsc'
import internshipCertify from '../../assets/internship-certify.pdf'

const About = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={About_Me} alt="about me" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">

            <article className='about__card'>
              <FaAward className='about__icon'/>
              <h5>Experience</h5>
              <small>2+ Years Working</small>
            </article>

            <article className='about__card'>
              <VscFolderLibrary className='about__icon'/>
              <h5>Projects</h5>
              <small>20+ Completed</small>
            </article>

            <article className='about__card'>
              <FiUsers className='about__icon'/>
              <h5>Client</h5>
              <small>0 Worldwide</small>
            </article>

          </div>
          <p style={{textAlign:"justify"}}>Innovative Web Developer with 2+ years of experience in website design and website developing. Demonstrated talent for front and back-end web development to optimize online presence. Seasoned expert in languages such as HTML, CSS and SASS as well as scripting JavaScript, ReactJS, NextJS, NodeJS, ExpressJS and many more.</p>
          <a href="#contact" className='btn btn-primary'>Let's Talk</a>
        </div>
      </div>
    </section>
  )
}

export default About